const BaseCategoryPage = require('base/category-page');
const Server = require('helper/server');

class ZcyHNCategory extends BaseCategoryPage {
  constructor() {
    super({
      events: {
        'click .search-btn': 'handleSearch',
        'click .reset-btn': 'handleReset',
        'click .expand': 'handleExpand',
        'click .collapse': 'handleCollapse'
      }
    });
    this.procurementMenuMode = [];

    this.initDateFlag = true;

    var myDate = new Date();
    var nowY = myDate.getFullYear();
    var nowM = myDate.getMonth() + 1;
    var nowD = myDate.getDate();
    this.endDate = nowY + '-' + (nowM < 10 ? '0' + nowM : nowM) + '-' + (nowD < 10 ? '0' + nowD : nowD); //当前日期
    // 获取三十天前日期
    var lw = new Date(myDate - 1000 * 60 * 60 * 24 * 30);
    var lastY = lw.getFullYear();
    var lastM = lw.getMonth() + 1;
    var lastD = lw.getDate();
    this.startDate = lastY + '-' + (lastM < 10 ? '0' + lastM : lastM) + '-' + (lastD < 10 ? '0' + lastD : lastD); //三十天之前日期
    // console.log(this.endDate, this.startDate);

    this.initPage();
  }

  initPage() {
    this.initDate();
    this.initHeighSearch();
    const query = this.query.params || {};
    // console.log('initPage=query', query);
    if (query.date) {
      $('input[name=publishDateBegin]').val(this.startDate);
      $('input[name=publishDateEnd]').val(this.endDate);
    }
  }

  async initHeighSearch() {
    const payload = {
      queryWithCode: true,
      includeAllNode: false,
      includeSelf: false,
      filterNotActive: false,
    };
    const { data: districtList } = await Server.getAnnouncementDistrict(payload);
    const $root = $('.block__search form');
    const district = $root.find('select[name="districtCode"]');
    let options = '<option value="">请选择</option>';
    $.map(districtList, item => {
      options += `<option value="${item.code}">${item.name}</option>`;
    });
    district.html(options);
    this.procurementMenuMode = await Server.queryProcurementMenuMode();
  }

  initDate() {
    const $date = $('.date-range .date');
    $date.datetimepicker({
      format: 'yyyy-mm-dd',
      autoclose: true,
      maxView: 4,
      minView: 2,
      language: 'zh-CN'
    });
  }

  search() {
    const { showContent, code } = this.selectedTreeNode;
    const $form = this.$el.find('.block__search_wrap');
    const formItem = $form.find('.form_item');
    const query = this.query.params || {};
    console.log('query', query);
    const payload = {
      ...query,
      categoryCode: code,
      pageSize: this.pageSize,
      pageNo: this.pageNo
    };
    $.map(formItem, item => {
      const key = $(item).attr('name');
      const value = $(item).val();
      if (value !== '' && value !== null) {
        if (key === 'districtCode') {
          if (payload[key]) {
            payload[key].push(value);
          } else {
            payload[key] = [value];
          }
        } else {
          payload[key] = value;
        }
      }
    });
    if (this.initDateFlag && query.date) {
      this.initDateFlag = false;
      payload.publishDateBegin = this.startDate;
      payload.publishDateEnd = this.endDate;
    }
    Server.searchCategory(payload).then(res => {
      this.renderList(res);
    });
  }

  handleSearch() {
    this.search();
  }

  handleReset() {
    const $form = this.$el.find('.block__search_wrap');
    $form[0].reset();
    this.search();
  }

  handleExpand() {
    const $root = $('.block__search form');
    const procurement = $root.find('select[name="procurementMethodCode"]');
    let options = '<option value="">请选择</option>';
    $.map(this.procurementMenuMode, item => {
      options += `<option value="${item.code}">${item.name}</option>`;
    });
    procurement.html(options);
    $('.block__search').animate(
      {
        height: '162px'
      },
      100,
      '',
      () => {
        // $( '.block__search' ).css( 'overflow', 'unset' );
        $('.block__search').removeClass('overHiden');
      }
    );
    this.$el.find('.expand, .collapse').toggle();
  }

  handleCollapse() {
    $('.block__search').addClass('overHiden');
    $('.block__search').animate(
      {
        height: '58px',
        overflow: 'hidden'
      },
      100
    );
    this.$el.find('.expand, .collapse').toggle();
  }
}

module.exports = ZcyHNCategory;
